"use client"

import * as React from "react"

import Image from "next/image"
import checkMark from "/public/hire/check_circle.webp"
import Image0 from "/public/hire/image0.webp"
import Image1 from "/public/hire/image1.webp"
import Image2 from "/public/hire/image2.webp"
import { trackEvent } from "../../analytics"

/* Form */
import axios from "axios"
import { useState } from "react"

import {
	Card,
	CardContent,
	CardFooter,
} from "@/components/ui/card"

import { useFormik } from "formik"
import * as Yup from "yup"

import { Input } from "@/components/ui/input"

import { cn } from "@/lib/utils"

import { Icons } from "@/components/hire/icons"
import { motion, useAnimation, useInView } from "framer-motion";
import { useContext } from "react"
import { advertiserAnalyticOptions } from "@/utils/functions"


import { isMobile } from "@/lib/utils"
import { SharedContext } from "@/context/SharedContext"
import { AdvertiserContext } from "@/context/AdvertiserContext"
/* Form */

export default function Dashboard({formpopup=false,setformpopup=(pop:boolean)=>{}}) {

	const [loading, setLoading] = useState(false)

	const { utmParams } = useContext(SharedContext);
 const { enterpriseLoginDetails } = useContext(AdvertiserContext);


	const [apiError, setApiError] = useState(null)
	const [OnSuccess, setOnSuccess] = useState(false)

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: "",
			mobile_no: "",
			email: "",
			num_of_openings: "",
		},
		validationSchema: Yup.object({
			name: Yup.string().matches(/^\s*[a-zA-Z]( {0,2}[a-zA-Z])*\s*$/,"Enter a valid name.").required("Please enter your name."),
			mobile_no: Yup.string()
				.matches(
					/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
					"Invalid phone number. Please try again.",
				)
				.min(10, "Invalid phone number. Please try again.")
				.max(10, "Invalid phone number. Please try again.")
				.required("Please enter mobile number."),
			email: Yup.string().matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, "Please provide a valid mail Id.").required("Please enter your email ID."),
			num_of_openings: Yup.number().max(100, "openings can not be of more than 3 characters.").required("Please enter number of openings."),
		}),
		validate: (values:any) => {
			// console.log(values.preferred_languages)
		},
		onSubmit: (values:any) => {
			// alert(JSON.stringify(values, null, 2))
			setLoading(true)
			axios
				.post(
					`${process.env.NEXT_PUBLIC_BASE_URL_ADS}/enterprise/leads/capture/`,
					{ email: values.email, name: values.name, mobile_no: values.mobile_no, num_of_openings: values.num_of_openings.toString() },
					{ headers: { "Content-Type": "application/json" } },
				)
				.then((v) => {
					setLoading(false)
					setOnSuccess(true)
				})
				.catch((ex) => {
					setLoading(true)
					setApiError(ex.response.data.message)
				})
		
		},
	
	})
	const ref = React.useRef(null);
	const isInView = useInView(ref, { once: true });
	const control = useAnimation();
	React.useEffect(() => {
		if (isInView) {
			control.start("visible")
		}
	}, [isInView])
	React.useEffect(()=>{

		if(formpopup){
		  document.body.classList.add('no-scroll')
		  document.body.style.overflow ="hidden";
		}else{
		  document.body.classList.remove('no-scroll')
		  document.body.style.overflow ="auto";
		}
	  },[formpopup])
	
	return (
		<section className="bg-sectionbg px-[16px] md:px-[0px] pb-[192px] md:pb-[144px] pt-[96px] overflow-hidden flex flex-wrap md:flex-nowrap  justify-between lg:gap-x-[80px] md:gap-x-[48px]">
			<div
				className={
					"relative w-full md:w-[50%] order-last md:order-none pt-[300px] md:mt-[0px]"
				}
			>
				<Image
					src={Image0}
					className={
						"lg:w-[auto] w-full h-[200px] md:h-[300px] lg:h-[425px] absolute bottom-[0px] md:top-[0px] left-[0px] z-0 translate-x-[0px] lg:-translate-x-[240px] md:-translate-x-[56px] mx-[auto]"
					}
					width={0}
					height={0}
					alt={""}
				/>
				<div className={"right-[0px] top-[56px] z-10 absolute w-full"}>
					<div className="flex justify-center items-center">
						<Image
							src={Image1}
							className={
								"lg:w-[379px] md:w-auto w-[182px] md:ml-auto md:mr-[0px] h-[95px] md:h-[115px] lg:h-[198px] rounded-[12px]"
							}
							width={0}
							height={0}
							alt={""}
						/>
					</div>
				</div>

				<div
					className={
						"z-10 absolute bottom-[0px] translate-y-[48px]  lg:translate-y-[80px] md:-translate-y-[40px] md:left-[40px] w-full"
					}
				>
					<div className="flex justify-center items-center">
						<Image
							src={Image2}
							className={
								"w-[247px] h-[132px] lg:w-[360px] lg:h-[192px] rounded-[12px] mx-[auto] md:mr-[auto] md:ml-[0px]"
							}
							width={0}
							height={0}
							alt={""}
						/>
					</div>
				</div>
			</div>
			<motion.div className={"w-full md:w-[50%]"}
				ref={ref}
				variants={{
					hidden: { opacity: 0, y: 95 },
					visible: { opacity: 1, y: 0 }
				}} transition={{ duration: 0.8, delay: 0.2 }} initial={"hidden"} animate={control} >
				<p
					className={
						"bg-textLevel notoSansBold text-[14px] leading-[20px] text-white rounded-[4px] px-[8px] py-[4px] w-max mb-[0px]"
					}
				>
					NEW
				</p>
				<h3 className={"custom-text"}>Enterprise Solutions</h3>
				<h1 className={"sectiontitle w-auto"}>Try out Lokal Enterprise Dashboard</h1>
				<div className={"points mb-[20px] md:mb-[32px]"}>
					<ul className={""}>
						<li className={""}>
							<Image
								src={checkMark}
								className={"w-auto h-[24px] md:h-[28px]"}
								width={0}
								height={0}
								alt={""}
							/>
							<p className="mb-[0px]">Verified Candidates</p>
						</li>
						<li className={""}>
							<Image
								src={checkMark}
								className={"w-auto h-[24px] md:h-[28px]"}
								width={0}
								height={0}
								alt={""}
							/>
							<p className="mb-[0px]">Personalized Dashboard</p>
						</li>
						<li className={""}>
							<Image
								src={checkMark}
								className={"w-auto h-[24px] md:h-[28px]"}
								width={0}
								height={0}
								alt={""}
							/>
							<p className="mb-[0px]">Access to Candidate Database</p>
						</li>
					</ul>
				</div>
				<button
					onClick={() => {
						setformpopup(true)
						// @ts-ignore
						trackEvent({ name: 'tap_try_ent', options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId}),label:"landing_page",section:"enterprise_cta",searchParams:utmParams}})
					}}
					type={"submit"}
					className="btn w-[172px] cursor-pointer"
				>
					Try Now
				</button>
			</motion.div>
			{formpopup && <div data-state={`${formpopup ? "open" : "closed"}`} className="fixed inset-0 z-[9999] bg-[#595959]/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" style={{pointerEvents: "auto"}} data-aria-hidden="true" aria-hidden="true"></div>}
			{formpopup && <div data-state={formpopup ? "open" : "closed"} className={`${isMobile() ? "fixed gap-4 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500 inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom lg:min-w-[50%] md:min-w-[75%] z-[999999] rounded-tr-[24px] rounded-tl-[24px] min-h-max p-[16px] bg-white" : "fixed gap-4 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500 inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm lg:min-w-[50%] md:min-w-[75%] z-[999999] rounded-tl-[24px] rounded-bl-[24px] min-h-screen p-[36px] bg-popUp flex items-center justify-center"}`}>

				{!OnSuccess && 
				<div className={"space-y-[25px] text-center md:p-[16px] p-[0px]"}>
					<div className="flex justify-end absolute top-2.5 right-2.5" onClick={()=>{setformpopup(false)}}>
					<Icons.crossIcon
						className={"w-auto h-[40px] cursor-pointer"} />
					</div>
					
					<h1
						className={
							"popup-title helvetica-bold text-[28px] leading-[39px] md:text-[30px] md:leading-[36px] lg:text-[36px] md:px-[40px] px-[0px] text-title mx-[auto]"
						}
					>
						Share your details and we will get back to you !
					</h1>
					<Card
						className={cn(
							"shadow-none border-none rounded-[16px] md:px-[40px] md:py-[32px] p-[0px] w-full md:w-[465px] mx-[auto]",
						)}
					>

						<form
							onSubmit={(e)=>{
								e.preventDefault()
								trackEvent({ name: 'ent_form_submitted', searchParams: utmParams || {}, options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId,category:"conversion"}),device_type:isMobile()?"mobile":"web",label:"landing_page"} })
								formik.handleSubmit()
							}}
						>
							<CardContent className="grid gap-[24px] p-[0px]">
								<div className="flex flex-wrap gap-y-[16px]">
									<div className="w-full">
										<div className={"relative"}>
											<Input
												autoComplete={"off"}
												placeholder=""
												type="text"
												defaultValue={formik.values.name}
												onClick={() => { }}
												onChange={(e) => {
													if(e.target.value.length===1)
													{
														trackEvent({ name: 'ent_form_name', searchParams: utmParams || {}, options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId}),device_type:isMobile()?"mobile":"web",label:"landing_page"} })

													}
												
													formik.setFieldValue("name", e.target.value)
												}}
												id="name"
												className={`block px-[10px] pb-[10px] pt-[16px] w-full h-[48px] placeholder:text-inputText text-title text-[14px] leading-[20px] font-normal bg-transparent rounded-[8px] custom-input-border appearance-none  focus:outline-none focus:ring-0 focus:border-[2px] focus:border-borderRing peer ${formik.touched.name &&
													formik.errors.name &&
													"border-errorMsg border-[2px] border-opacity-100"
													}`}
											/>
											<label
												htmlFor="name"
												className="ml-[10px] left-[0px] absolute text-[14px] leading-[20px] text-inputText  duration-300 transform -translate-y-[16px] scale-75 top-[8px] z-10 origin-[0] bg-white  px-[8px] peer-focus:px-[8px] peer-focus:text-borderRing  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
												peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-[16px] rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-[auto] start-1"
											>
												Full Name
											</label>
										</div>
										{formik.touched.name && formik.errors.name ? (
											<div className={"text-errorMsg text-left text-[12px] py-[8px] px-[16px]"}>
												{formik.errors.name}
											</div>
										) : null}
									</div>
									<div className="w-full">
										<div className="relative">
											<Input
												autoComplete={"off"}
												placeholder=""
												type="text"
												id="emailId"
												value={formik.values.email}
												className={`block px-[10px] pb-[10px] pt-[16px] w-full h-[48px] placeholder:text-inputText text-title text-[14px] leading-[20px] font-normal bg-transparent rounded-[8px] custom-input-border appearance-none  focus:outline-none focus:ring-0 focus:border-[2px] focus:border-borderRing peer ${formik.touched.email &&
													formik.errors.email &&
													"border-errorMsg border-[2px] border-opacity-100"
													}`}
												onChange={(e) => {
													if(e.target.value.length===1)
													{
														trackEvent({ name: 'ent_form_email', searchParams: utmParams || {}, options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId}),device_type:isMobile()?"mobile":"web",label:"landing_page"} })

													}
													formik.setFieldValue("email", e.target.value)
												}}
											/>
											<label
												htmlFor="emailId"
												className="ml-[10px] left-[0px] absolute text-[14px] leading-[20px] text-inputText  duration-300 transform -translate-y-[16px] scale-75 top-[8px] z-10 origin-[0] bg-white px-[8px] peer-focus:px-[8px] peer-focus:text-borderRing  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
												peer-focus:top-[8px] peer-focus:scale-75 peer-focus:-translate-y-[16px] rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-[auto] start-1"
											>
												Email ID
											</label>
										</div>

										{formik.touched.email && formik.errors.email ? (
											<div className={"text-errorMsg text-left text-[12px] py-[8px] px-[16px]"}>
												{formik.errors.email}
											</div>
										) : null}
									</div>
									<div className="w-full">
										<div className={"relative"}>
											<Input
												autoComplete={"off"}
												placeholder=""
												type="text"
												id="mobile_no"
												onClick={() => { }}
												onChange={(e) => {
													if(e.target.value.length===1)
													{
														trackEvent({ name: 'ent_form_number', searchParams: utmParams || {}, options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId}),device_type:isMobile()?"mobile":"web",label:"landing_page"} })

													}
													formik.setFieldValue("mobile_no", e.target.value)
												}}
												value={formik.values.mobile_no}
												className={`block px-[10px] pb-[10px] pt-[16px] w-full h-[48px] placeholder:text-inputText text-title text-[14px] leading-[20px] font-normal bg-transparent rounded-[8px] custom-input-border appearance-none  focus:outline-none focus:ring-0 focus:border-[2px] focus:border-borderRing peer ${formik.touched.mobile_no &&
													formik.errors.mobile_no &&
													"border-errorMsg border-[2px] border-opacity-100"
													}`}
											/>
											<label
												htmlFor="mobile_no"
												className="ml-[10px] left-[0px] absolute text-[14px] leading-[20px] text-inputText  duration-300 transform -translate-y-[16px] scale-75 top-[8px] z-10 origin-[0] bg-white px-[8px] peer-focus:px-[8px] peer-focus:text-borderRing  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
												peer-focus:top-[8px] peer-focus:scale-75 peer-focus:-translate-y-[16px] rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-[auto] start-1"
											>
												Phone number
											</label>
										</div>
										{formik.touched.mobile_no && formik.errors.mobile_no ? (
											<div className={"text-errorMsg text-left text-[12px] py-[8px] px-[16px]"}>
												{formik.errors.mobile_no}
											</div>
										) : null}

									</div>
									<div className="w-full">
										<div className={"relative"}>
											<Input
												autoComplete={"off"}
												placeholder=""
												type="text"
												id="no_openings"
												className={`block px-[10px] pb-[10px] pt-[16px] w-full h-[48px] placeholder:text-inputText text-title text-[14px] leading-[20px] font-normal bg-transparent rounded-[8px] custom-input-border appearance-none  focus:outline-none focus:ring-0 focus:border-[2px] focus:border-borderRing peer ${formik.touched.num_of_openings &&
													formik.errors.num_of_openings &&
													"border-errorMsg border-[2px] border-opacity-100"
													}`}
												value={formik.values.num_of_openings}
												onChange={(e) => {
													if(e.target.value.length===1)
													{
														trackEvent({ name: 'ent_form_openings', searchParams: utmParams || {}, options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId,category:"conversion"}),device_type:isMobile()?"mobile":"web",label:"landing_page"} })

													}
													formik.setFieldValue("num_of_openings", e.target.value)
												}}
											/>
											<label
												htmlFor="no_openings"
												className="ml-[10px] left-[0px] absolute text-[14px] leading-[20px] text-inputText  duration-300 transform -translate-y-[16px] scale-75 top-[8px] z-10 origin-[0] bg-white px-[8px] peer-focus:px-[8px] peer-focus:text-borderRing  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
												peer-focus:top-[8px] peer-focus:scale-75 peer-focus:-translate-y-[16px] rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-[auto] start-1"
											>
												Number of Openings
											</label>
										</div>
										{formik.touched.num_of_openings && formik.errors.num_of_openings ? (
											<div className={"text-errorMsg text-left text-[12px] py-[8px] px-[16px]"}>
												{formik.errors.num_of_openings}
											</div>
										) : null}
									</div>
									{apiError && (
										<div className={"text-errorMsg text-left text-[12px] py-[8px] px-[16px]"}>
											{apiError}
										</div>
									)}
								</div>
							</CardContent>

							<CardFooter className="p-[0px] mt-[16px]">
								<button
									type={"submit"}
									className="btn "
								>
									{loading ? <Icons.loadingIcon /> : "Submit"}
								</button>
							</CardFooter>
						</form>
					</Card>

				</div>}
				{OnSuccess &&
					<div className={`space-y-[25px] text-center p-[0px] md:p-[16px]`}>
						<Icons.okIcon className={"w-auto h-[80px]"} />
						<div className={"space-y-[25px] md:space-y-2"}>
							<h1
								className={
									"popup-title helvetica-bold text-[28px] leading-[39px] md:text-[30px] lg:text-[36px] md:leading-[49px] md:px-[40px] px-[0px] text-title mx-[auto]"
								}
							>
								Thank you for sharing!
							</h1>
							<p
								className={
									"text-sectionTitle text-[20px] leading-[28px] w-[70%] md:w-[50%] mx-[auto] mb-[0px]"
								}
							>
								Our team will reach out to you shortly
							</p>
						</div>
						<button
							type={"submit"}
							className="btn"
							onClick={() => setformpopup(false)}
						>
							{loading ? <Icons.loadingIcon /> : "Okay, Got it"}
						</button>
					</div>
				}
			</div>}
		</section>
	)
}
